<template>
  <div class="bio-container" :style="$vuetify.breakpoint.width > 700 ? 'background-image: url(https://images.avishkaar.cc/misc/profile/images/profile-banner-' + (['blue', 'green', 'yellow', 'orange', 'pink'].includes(this.profileData.color) ? this.profileData.color : 'blue') + '.png);background-size: 100% 100%;background-position: center;' : 'background-image: url(https://images.avishkaar.cc/misc/profile/images/profile-banner-mobile-' + (['blue', 'green', 'yellow', 'orange', 'pink'].includes(this.profileData.color) ? this.profileData.color : 'blue') + '.png);background-size: 100% 100%;background-position: center;'">
    <div class="avatar-section">
      <div class="avatar">
        <input class="new-avatar" id="new-avatar-profile" type="file" accept="image/jpeg, image/png, image/jpg" @change="uploadProfile" v-if="profileData.user_type == 'parent' && accessProfile">
        <label for="new-avatar-profile" class="new-avatar-label" v-if="profileData.user_type == 'parent' && accessProfile"><img :src="(profileData.profile_img && profileData.profile_img!='0') ? 'https://images.avishkaar.cc/misc/profile/utility/edit-avatar-icon.png' : 'https://images.avishkaar.cc/misc/profile/utility/add-avatar-icon.png'" class="label-img" /></label>
        <img :src="profileData.profile_img" alt="Avatar" class="avatar" v-if="profileData.profile_img && profileData.profile_img!='0'" />
        <img src="https://images.avishkaar.cc/misc/profile/images/default-avatar.png" alt="Avatar" class="avatar" v-else />
      </div>
      <div class="name" style="text-transform: capitalize">{{profileData.username}}</div>
    </div>
    <div class="about-section">
      <div class="bio-empty" :class="!accessProfile && 'bio-empty-no-access'" v-if="profileData.profile_description == null && !add">
        <div class="description" :class="!accessProfile && 'description-no-access'">
          <div v-if="accessProfile" class="title">About Myself</div>
          <div v-else class="title" style="text-transform: capitalize">About {{profileData.username}}</div>
          <div class="sub-title" v-if="accessProfile">
            Your Uniqueness Makes You A True Innovator
          </div>
          <div class="content no-access" v-else>
            No Description Has Been Added Yet
          </div>
          <div class="content" v-if="accessProfile">
            Let the world know about your personality, skills, mission and what
            sets you apart from the crowd...
          </div>
        </div>
        <button v-if="accessProfile" class="orange-button" @click="add=true">Add Description</button>
      </div>
      <div class="bio-filled" v-if="profileData.profile_description != null && !add">
        <div class="description">
          <div class="title-container">
            <div v-if="accessProfile" class="title">About Myself</div>
            <div v-else class="title" style="text-transform: capitalize">About {{profileData.username}}</div>
            <button v-if="accessProfile" style="outline: none" @click="add=true">
              <img alt="Edit" width="16" height="16" src="https://images.avishkaar.cc/misc/profile/utility/edit-icon-orange.png" />
            </button>
          </div>
          <div class="content scrollbar">
            {{profileData.profile_description}}
          </div>
        </div>
      </div>
      <div class="bio-edit" v-if="add && accessProfile">
        <div class="description">
          <div class="title-container">
            <div class="title">About Myself</div>
            <button style="outline:none" @click="add=false">
              <img alt="Cancel" width="16" height="16" src="https://images.avishkaar.cc/misc/profile/utility/cross-icon-orange.png" />
            </button>
          </div>
          <div class="sub-title">
            Describe Yourself In The Best Way Possible !
          </div>
          <textarea placeholder="Start Typing..." class="add-description content scrollbar" v-model="description" autofocus />
        </div>
        <button class="orange-button" @click="addDescription">{{descriptionButton}}</button>
      </div>
    </div>
    <v-dialog v-model="cropper" width="unset" persistent :fullscreen="$vuetify.breakpoint.width < 600">
      <div class="image-cropper">
        <div class="cropper-title">Crop Your Image</div>
        <img class="cancel" src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" @click="Cancel" title="Cancel" />
        <div class="crop-container">
          <div class="clipper-container" v-if="src && !preview">
            <clipper-fixed ref="clipper" class="clipper" :src="src" />
          </div>
          <button class="orange-button" @click="Crop" v-if="src && !preview">Crop Image</button>
          <img class="preview-img" :src="preview" v-if="preview">
          <div class="button-container" v-if="preview">
            <button class="orange-button white-button" @click="CropAgain">Crop Again</button>
            <button class="orange-button" @click="UploadImage">Upload Image</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Bio",
  props: ["accessProfile"],
  data() {
    return {
      description: null,
      add: false,
      cropper: false,
      descriptionButton: "Add Description",
      src: null,
      preview: null,
      preview_name: null,
    }
  },
  computed: {
    ...mapGetters({ profileData: "getUserProfileData" }),
  },
  methods: {
    ...mapActions(["updateProfileDescription","updateParentProfile"]),
    addDescription(){
        if(this.description){
          this.updateProfileDescription({profile_description : this.description})
          this.add = false
        }
    },
    uploadProfile(event){
        this.cropper = true;
        let file = event.target.files[0];
        event.target.value = null;
        this.preview_name = file.name;
        let reader = new FileReader()
        reader.onload = (e) => { this.src = e.target.result }
        reader.readAsDataURL(file);
    },
    UploadImage() {
      let data = new FormData();
      data.append('fileName', this.profileData.username);
      data.append('fileUpload', this.dataURItoBlob(this.preview), this.preview_name);
      this.updateParentProfile(data).then(() => this.Cancel());
    },
    Crop() {
      let canvas = this.$refs.clipper.clip();
      this.preview = canvas.toDataURL("image/jpeg", 1);
    },
    CropAgain() {
      this.preview = null;
    },
    dataURItoBlob(dataURI) {
      let byteString = atob(dataURI.split(',')[1]);
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ab], {type: mimeString});
      return blob;
    },
    Cancel() {
      this.cropper = false;
      this.src = null;
      this.preview = null;
      this.preview_name = null;
    }
  },
  created() {
    if (this.profileData.profile_description != null) {
      this.description = this.profileData.profile_description;
      this.descriptionButton= "Save";
    };
  },
};
</script>

<style lang="scss" scoped>
.bio-container {
  display: flex;
  width: 100%;
  height: 100%;
  background: url("https://images.avishkaar.cc/misc/profile/images/profile-banner.png");
  background-size: 100% 100%;
  background-position: center;
  .avatar-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 35%;
    height: 100%;
    .avatar {
      width: 250px;
      height: 250px;
      border-radius: 50%;
      .new-avatar {
        position: absolute;
        display: none;
      }
      .new-avatar-label {
        width: 37px;
        height: 37px;
        position: absolute;
        background: white;
        border-radius: 50%;
        cursor: pointer;
        margin: 11.5rem 0 0 12.7rem;
        line-height: 0;
        .label-img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
    .name {
      font-size: 1.5rem;
      color: #303030;
      font-family: Poppins;
      font-weight: 700;
      margin-top: 3%;
    }
  }
  .about-section {
    display: flex;
    align-items: center;
    width: 65%;
    height: 100%;
    .bio-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      border-radius: 12px;
      width: 80%;
      height: 70%;
      background: white;
      padding: 2.5%;
      box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
      .description {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 48%;
        text-align: left;
        .title {
          margin-bottom: 2%;
        }
      }
      .orange-button {
        width: 50%;
        height: 18%;
      }
    }
    .bio-empty-no-access {
      height: 40%;
      .description-no-access {
        justify-content: flex-start;
      }
    }
    .bio-edit {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      border-radius: 12px;
      width: 80%;
      height: 70%;
      background: white;
      padding: 2.5%;
      box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
      .description {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 75%;
        text-align: left;
        .title-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          text-align: left;
          margin-bottom: 2%;
        }
        .add-description {
          border: none;
          outline: none;
          padding: 0;
          box-shadow: none;
          resize: none;
          height: 50%;
          // why placeholder color is not working
          &::placeholder {
            color: #303030;
          }
        }
      }
      .orange-button {
        width: 50%;
        height: 18%;
      }
    }
    .bio-filled {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      border-radius: 12px;
      width: 80%;
      height: 48%;
      background: white;
      padding: 2.5%;
      box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
      .description {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        text-align: left;
        .title-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          text-align: left;
          margin-bottom: 3%;
        }
        .content {
          width: 100%;
          padding-right: 5%;
          overflow: auto;
          height: 100%;
        }
      }
    }
  }
}
.title {
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: #303030;
}
.sub-title {
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  color: #303030;
}
.content {
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: 400;
  color: #303030;
}
.orange-button {
  font-family: Roboto;
  outline: 0;
  font-size: 1rem;
  font-weight: 500;
  background: #f36f2e;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
}
.scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #9c9c9c;
}
@media all and (max-width: 1000px) {
  .bio-container {
    .avatar-section {
      width: 40%;
      .avatar {
        width: 200px;
        height: 200px;
        .new-avatar-label {
          width: 29.6px;
          height: 29.6px;
          margin: 9.3rem 0 0 10rem;
        }
      }
    }
    .about-section {
      width: 65%;
      .bio-empty {
        width: 90%;
      }
      .bio-edit {
        width: 90%;
        .bio-filled {
          width: 90%;
        }
      }
    }
  }
}
@media all and (max-width: 700px) {
  .bio-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: url("https://images.avishkaar.cc/misc/profile/images/profile-banner-mobile.png");
    background-size: 100% 100%;
    background-position: center;
    .avatar-section {
      flex-direction: row;
      justify-content: center;
      width: 100%;
      height: 35%;
      .avatar {
        width: 125px;
        height: 125px;
        margin-right: 0.5rem;
        .new-avatar-label {
          width: 25px;
          height: 25px;
          margin: 5.8rem 0 0 6rem;
        }
      }
      .name {
        font-size: 1.25rem;
        margin: 0.5rem;
      }
    }
    .about-section {
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      height: 65%;
      .bio-empty {
        width: 90%;
        height: 90%;
        padding: 5%;
        .description {
          height: 55%;
        }
        .orange-button {
          width: 80%;
          margin-bottom: 5%;
        }
      }
      .bio-empty-no-access {
        height: 70%;
        .description-no-access {
          .no-access{
            margin: 0.5rem 0;
          }
        }
      }
      .bio-edit {
        width: 90%;
        height: 90%;
        padding: 5%;
        .orange-button {
          width: 80%;
          margin-bottom: 5%;
        }
      }
      .bio-filled {
        width: 90%;
        height: 90%;
        padding: 5%;
        .description {
          .title-container {
            margin-bottom: 5%;
          }
        }
      }
    }
  }
  .title {
    font-size: 1.25rem;
  }
  .sub-title {
    font-size: 1rem;
  }
  .content {
    font-size: 0.875rem;
  }
}
@media all and (max-width: 450px) {
  .bio-container {
    .avatar-section {
      width: 90%;
      justify-content: flex-start;
    }
  }
}
</style>

<style lang="scss" scoped>
.image-cropper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 600px;
  height: 500px;
  min-height: 450px;
  background-color: #ffffff;
  .cancel {
    position: absolute;
    right: 2rem;
    top: 2rem;
    cursor: pointer;
  }
  .cropper-title {
    position: absolute;
    top: 1.5rem;
    font-size: 1.5rem;
    font-family: Poppins;
    font-weight: 700;
    color: #303030;
  }
  .crop-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 2rem;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 2rem;
    .clipper-container {
      width: 300px;
      .clipper {
        max-width: 300px;
      }
    }
    .preview-img {
      width: 300px;
      border-radius: 50%;
      border: 1px solid #cacaca;
    }
    .orange-button {
      padding: 0.5rem 2rem;
    }
    .white-button {
      background-color: #ffffff;
      color: #f36f2e;
    }
    .button-container {
      display: flex;
      gap: 1rem;
    }
  }
  @media screen and (max-width: 600px) {
    width: 100%;
    height: 100%;
    .crop-container {
      justify-content: center;
      .clipper-container {
        width: 100%;
        .clipper {
          max-width: 100%;
        }
      }
      .preview-img {
        width: 250px;
      }
      .orange-button {
        font-size: 0.875rem;
        padding: 0.5rem 1rem;
      }
    }
  }
}
</style>